export default __webpack_public_path__ + "static/media/Logo_MongoDB.b3cedf8e.png";